var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.1,
    height: 14.196,
    viewBox: "0 0 22.1 14.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5723",
    "data-name": "Group 5723",
    transform: "translate(-1391.75 -329.9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1944",
    "data-name": "Line 1944",
    x2: 20,
    transform: "translate(1393 330.75)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1949",
    "data-name": "Line 1949",
    x2: 17,
    transform: "translate(1392.6 336.998)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1953",
    "data-name": "Line 1953",
    x2: 12,
    transform: "translate(1392.68 343.246)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLine);
export default __webpack_public_path__ + "static/media/multiLine.cdb456eae8ac67acd4e67a6dc4d2a05d.svg";
export { ForwardRef as ReactComponent };